import { useState, useEffect } from 'react';
import content from '../content.json';
const pub = process.env.PUBLIC_URL;

export default function Hero() {
  const [current, setCurrent] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const slides = content.hero.slides;

  useEffect(() => { setTimeout(() => setLoaded(true), 200); }, []);
  useEffect(() => {
    const t = setTimeout(() => setCurrent((current + 1) % slides.length), 5500);
    return () => clearTimeout(t);
  }, [current, slides.length]);

  return (
    <section id="hero" style={{ position: 'relative', height: '100vh', minHeight: '600px', overflow: 'hidden', background: '#0e0c0a' }}>
      {slides.map((slide, i) => (
        <div key={i} style={{ position: 'absolute', inset: 0, opacity: i === current ? 1 : 0, transition: 'opacity 1.5s ease' }}>
          <img src={`${pub}/${slide.image}`} alt={slide.alt} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to bottom, rgba(14,12,10,0.45) 0%, rgba(14,12,10,0.15) 50%, rgba(14,12,10,0.65) 100%)' }} />
        </div>
      ))}

      {/* Center text */}
      <div style={{
        position: 'absolute', inset: 0, zIndex: 2,
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        textAlign: 'center', padding: '0 32px',
        opacity: loaded ? 1 : 0, transform: loaded ? 'translateY(0)' : 'translateY(16px)',
        transition: 'opacity 1s ease 0.4s, transform 1s ease 0.4s',
      }}>
        <span style={{ fontFamily: 'var(--font-body)', fontSize: '11px', letterSpacing: '0.3em', textTransform: 'uppercase', color: 'var(--gold2)', display: 'block', marginBottom: '20px' }}>@silverkammer</span>
        {/* Title — NOT italic, weight 400 */}
        <h1 style={{ fontFamily: 'var(--font-title)', fontWeight: 400, fontStyle: 'normal', fontSize: 'clamp(1.8rem, 5vw, 4rem)', color: '#ffffff', lineHeight: 1.15, maxWidth: '700px', marginBottom: '16px' }}>
          {content.hero.title}
        </h1>
        <p style={{ fontFamily: 'var(--font-body)', fontSize: '13px', letterSpacing: '0.08em', color: 'rgba(255,255,255,0.65)', marginBottom: '36px' }}>{content.hero.subtitle}</p>
        {/* Search bar placeholder */}
        <div style={{ display: 'flex', gap: '0', background: 'rgba(255,255,255,0.95)', maxWidth: '600px', width: '100%' }}>
          <input readOnly placeholder="Check In" style={{ flex: 1, border: 'none', padding: '14px 20px', fontFamily: 'var(--font-body)', fontSize: '12px', background: 'transparent', color: '#333', outline: 'none', borderRight: '1px solid #ddd' }} />
          <input readOnly placeholder="Check Out" style={{ flex: 1, border: 'none', padding: '14px 20px', fontFamily: 'var(--font-body)', fontSize: '12px', background: 'transparent', color: '#333', outline: 'none', borderRight: '1px solid #ddd' }} />
          <input readOnly placeholder="Guests" style={{ flex: 1, border: 'none', padding: '14px 20px', fontFamily: 'var(--font-body)', fontSize: '12px', background: 'transparent', color: '#333', outline: 'none' }} />
          <button style={{ background: 'var(--gold)', border: 'none', padding: '14px 24px', fontFamily: 'var(--font-body)', fontSize: '11px', letterSpacing: '0.15em', textTransform: 'uppercase', color: 'white', cursor: 'pointer', whiteSpace: 'nowrap' }}>Check Now</button>
        </div>
      </div>

      {/* Arrows */}
      {['‹','›'].map((ch, idx) => (
        <button key={idx} onClick={() => setCurrent((current + (idx?1:-1) + slides.length) % slides.length)}
          style={{ position: 'absolute', top: '50%', transform: 'translateY(-50%)', [idx?'right':'left']: '20px', zIndex: 3, background: 'none', border: 'none', cursor: 'pointer', color: 'rgba(255,255,255,0.5)', fontSize: '28px', padding: '12px', transition: 'color 0.2s' }}
          onMouseEnter={e => e.currentTarget.style.color='white'} onMouseLeave={e => e.currentTarget.style.color='rgba(255,255,255,0.5)'}
        >{ch}</button>
      ))}

      {/* Dots */}
      <div style={{ position: 'absolute', bottom: '28px', left: '50%', transform: 'translateX(-50%)', display: 'flex', gap: '6px', zIndex: 3 }}>
        {slides.map((_, i) => (
          <button key={i} onClick={() => setCurrent(i)} style={{ width: i===current?'24px':'5px', height: '1px', background: i===current?'var(--gold2)':'rgba(255,255,255,0.3)', border: 'none', cursor: 'pointer', transition: 'all 0.3s', padding: 0 }} />
        ))}
      </div>
    </section>
  );
}
